document.addEventListener('DOMContentLoaded', () => {
  const modal_trigger = 'modal-order-takeout';
  const url_type = 'takeout';

  const modal = document.querySelector('[data-' + modal_trigger + ']');
  if (!modal) return;

  let previouslyFocused = null;

  function openModal() {
    previouslyFocused = document.activeElement;
    modal.classList.remove('hidden');
    modal.removeAttribute('inert');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    document.body.style.overflow = 'hidden';
    modal.setAttribute('tabindex', '-1');
    modal.focus();
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('inert', '');
    modal.removeAttribute('aria-modal');
    modal.removeAttribute('role');
    modal.removeAttribute('tabindex');
    document.body.style.overflow = '';
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function removeModalHash() {
    if (window.location.hash === '#' + modal_trigger) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  }

  function getUrls(venue) {
    if (!venue) return [];
    const key = url_type + '_urls';
    return Array.isArray(venue[key]) ? venue[key].filter((i) => i.url) : [];
  }

  function updateVenueInfo() {
    const venue = get_current_venue_info();
    if (!venue) return;

    const venueName = modal.querySelector('.venue-name');
    const venueAddress = modal.querySelector('.venue-address');
    const venuePhone = modal.querySelector('.venue-phone');
    const optionsContainer = modal.querySelector('.order-select-options');

    if (venue.name) {
      venueName.textContent = venue.name;
      venueName.classList.remove('hidden');
    } else {
      venueName.classList.add('hidden');
    }

    if (venue.address) {
      venueAddress.textContent = venue.address;
      venueAddress.classList.remove('hidden');
    } else {
      venueAddress.classList.add('hidden');
    }

    if (venue.telephone) {
      venuePhone.textContent = venue.telephone;
      venuePhone.classList.remove('hidden');
    } else {
      venuePhone.classList.add('hidden');
    }

    const urls = getUrls(venue);
    optionsContainer.innerHTML = '';
    urls.forEach((item) => {
      const link = document.createElement('a');
      link.href = item.url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.className = 'btn-primary';
      link.textContent = item.title || item.url;
      optionsContainer.appendChild(link);
    });
  }

  modal.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'Escape':
        removeModalHash();
        break;
      case 'Tab':
        const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
        break;
    }
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      removeModalHash();
    }
  });

  modal.querySelector('.close-modal').addEventListener('click', (e) => {
    e.preventDefault();
    removeModalHash();
  });

  if (window.location.hash === '#' + modal_trigger) {
    updateVenueInfo();
    openModal();
  }

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#' + modal_trigger) {
      updateVenueInfo();
      openModal();
    } else {
      closeModal();
    }
  });

  updateVenueInfo();
  document.body.addEventListener('venueChanged', (e) => {
    const isOpen = !modal.classList.contains('hidden');
    updateVenueInfo();

    if (isOpen) {
      const venue = get_current_venue_info();
      const urls = getUrls(venue);

      if (urls.length > 1) {
        return;
      } else if (urls.length === 1) {
        removeModalHash();
        window.open(urls[0].url, '_blank', 'noopener');
      } else {
        removeModalHash();
      }
    }
  });
});
